import { balanceService } from "services/balanceService"
import { ContainerHeader, ContainerPage } from "./styles"
import { PageTitle } from "components"
import { Table } from "shared"
import { useTableParams } from "hooks/useTableParams"
import { useEffect } from "react"

const DashReplenishment = () => {
  const { count, data, params, refresh, onChange, status } = useTableParams({
    service: (params: any) =>
      balanceService.getBalanceNeedReplenishment({ ...params, isStockout: "False" }),
  })

  useEffect(() => {
    const interval = setInterval(refresh, 30000)

    return () => clearInterval(interval)
  }, [])

  return (
    <ContainerPage style={{ height: "auto" }}>
      <ContainerHeader component="header" style={{ display: "flex", flexDirection: "column" }}>
        <PageTitle>Dashboard</PageTitle>
        <h2 style={{ marginTop: "10px", fontSize: "1.25rem", color: "#637381", fontWeight: 400 }}>
          Aqui você encontra os itens que necessitam abastecimento.
        </h2>
      </ContainerHeader>
      <Table
        columns={[
          {
            style: { fontSize: "1.2rem" },
            field: "skuName",
            label: "Produto",
          },
          {
            style: { fontSize: "1.2rem" },
            field: "totalSold",
            label: "Vendido",
          },
          {
            style: { fontSize: "1.2rem" },
            field: "totalReplenished",
            label: "Abastecido",
          },
          {
            style: { fontSize: "1.2rem" },
            field: "quantityInSeparation",
            label: "Operação",
          },
          {
            style: { fontSize: "1.2rem" },
            field: "marketNumber",
            label: "Mercado",
          },
          {
            style: { fontSize: "1.2rem" },
            field: "isInReplenishmentForWorkId",
            label: "Status",
            formatter: isInReplenishmentForWorkId =>
              isInReplenishmentForWorkId ? "Abastecendo" : "Aguardando",
          },
        ]}
        data={data}
        params={params}
        onChange={onChange}
        refresh={refresh}
        count={count}
        status={status}
        rowStyle={() => ({ ".MuiTableCell-root": { fontSize: "1.1rem" } })}
      />
    </ContainerPage>
  )
}

export default DashReplenishment
